import React, { useCallback, useContext, useEffect, useState } from "react";
import {Link, useNavigate} from "react-router-dom";
import { Navbar } from "../../components/Navbar/Navbar";
import { analysis } from "../../TestData";
import { Analysis } from "./Analysis/Analysis";
import "./test-analysis.scss";
import Icon from "../../assets/images/search.svg";

import Table from "react-bootstrap/Table";
import AuthContext from "../../context/AuthProvider";
import { useDispatch, useSelector } from "react-redux";
import { getQuestionAnalysis } from "../../store/actions/examActions";
import { GhostExamListLoader } from "../../components/Loaders/GhostExamListLoader";
import { ExamAnalysis } from "../../components/Exams/ExamAnalysis";
import { useMediaQuery } from "react-responsive";
import { GhostExamListMobileLoader } from "../../components/Loaders/GhostExamListMobileLoader";
import { ExamCardAnalysis } from "../../components/Exams/ExamCardAnalysis";
import { AnalysisFilter } from "../AnalysisDashboard/AnalysisFilter";
import {
  setGlobalAllAnalysisFilter,
  setGlobalAnalysisFilter,
  setGlobalEmailAnalysisFilter
} from "../../store/slices/adminSlice";
import Form from "react-bootstrap/Form";
import IconDetail from "../../assets/images/analyse.svg";
import {toast} from "react-toastify";


export const TestAnalysis = ({ isAdmin, isBusiness }) => {
  const navigate = useNavigate();
  isAdmin = isAdmin || isBusiness;
  const useDesktopMediaQuery = () =>
    useMediaQuery({ query: "(min-width: 769px)" });

  const useTabletAndBelowMediaQuery = () =>
    useMediaQuery({ query: "(max-width: 768px)" });

  const Desktop = ({ children }) => {
    const isDesktop = useDesktopMediaQuery();
    return isDesktop ? children : null;
  };

  const TabletAndBelow = ({ children }) => {
    const isTabletAndBelow = useTabletAndBelowMediaQuery();
    return isTabletAndBelow ? children : null;
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleSetShow = () => setShow(true);

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const modeData = ["Test", "Email"];
  const [sort, setSort] = useState("");
  const [mode, setMode] = useState("Test");
  const [allAnalysis, setAllAnalysis] = useState(false);
  const { user, isLoggedIn } = useContext(AuthContext);
  const businessId =
    user?.businessAccess?.businessId ||
    user?.businessAccess?.channelId ||
    user?.managedBusinessId;
  const { analysisdata, adminsdata } = useSelector((state) => state.exam);
  const dispatch = useDispatch();
  // const sortData = ["Newest", "Oldest", "Subject", "Year"];
  const [filterData, setFilterData] = useState({ search: "" });
  const [date, setDate] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [selectedEmailRecipients, setSelectedEmailRecipients] = useState({});
  const [selectAllEmailPages, setSelectAllEmailPages] = useState(false);

  const sortData = ["", "Highest Score"];

  const handleSort = (e) => {
    setSort(e.target.value);
  };

  const getRecipientKey = useCallback((recipient) => String(
    recipient.userId ??
    recipient.user_id ??
    recipient.examEmail ??
    recipient.email ??
    recipient.action
  ), []);

  const toEmailRecipient = useCallback((recipient) => ({
    key: getRecipientKey(recipient),
    email: recipient.examEmail || recipient.email,
    userId: recipient.userId ?? recipient.user_id,
    analysisId: recipient.action,
  }), [getRecipientKey]);

  const isRecipientSelected = useCallback(
    (recipient) => Boolean(selectedEmailRecipients[getRecipientKey(recipient)]),
    [getRecipientKey, selectedEmailRecipients]
  );

  const handleToggleRecipient = useCallback((recipient) => {
    const item = toEmailRecipient(recipient);
    if (selectAllEmailPages) {
      const currentPageRecipients = (analysisdata.pastQuestions || [])
        .filter((pageRecipient) => pageRecipient.examEmail || pageRecipient.email)
        .reduce((items, pageRecipient) => {
          const pageItem = toEmailRecipient(pageRecipient);
          if (pageItem.key !== item.key) items[pageItem.key] = pageItem;
          return items;
        }, {});
      setSelectAllEmailPages(false);
      setSelectedEmailRecipients(currentPageRecipients);
      return;
    }
    setSelectedEmailRecipients((current) => {
      const next = { ...current };
      if (next[item.key]) delete next[item.key];
      else next[item.key] = item;
      return next;
    });
  }, [analysisdata.pastQuestions, selectAllEmailPages, toEmailRecipient]);

  const handleToggleAllPages = useCallback((checked) => {
    setSelectAllEmailPages(checked);
    setSelectedEmailRecipients({});
  }, []);

  const handleToggleCurrentPageRecipients = useCallback((checked) => {
    if (selectAllEmailPages) setSelectAllEmailPages(false);
    setSelectedEmailRecipients((current) => {
      const next = { ...current };
      (analysisdata.pastQuestions || [])
        .filter((recipient) => recipient.examEmail || recipient.email)
        .forEach((recipient) => {
          const item = toEmailRecipient(recipient);
          if (checked) next[item.key] = item;
          else delete next[item.key];
        });
      return next;
    });
  }, [analysisdata.pastQuestions, selectAllEmailPages, toEmailRecipient]);

  const handleEmail = () => {
    const recipients = Object.values(selectedEmailRecipients);
    if (!selectAllEmailPages && !recipients.length) {
      toast.error("Select at least one email recipient");
      return;
    }
    const payload = JSON.parse(localStorage.getItem(`analysisFilters`) || "{}");
    payload.startDate = date;
    payload.endDate = dateEnd;
    payload.isAnalysis =  true;
    payload.selectAll = selectAllEmailPages;
    payload.selectedEmails = recipients.map((recipient) => recipient.email).filter(Boolean);
    payload.selectedUserIds = recipients
      .map((recipient) => recipient.userId)
      .filter((value) => value !== undefined && value !== null);
    payload.selectedAnalysisIds = recipients
      .map((recipient) => recipient.analysisId)
      .filter((value) => value !== undefined && value !== null);
    dispatch(setGlobalEmailAnalysisFilter(payload));
    navigate(`/admin/emails/new`,{replace: false});
  }

  const handleMode = (e) => {
    // console.log("change values: ",e.target.value);
    setMode(e.target.value);
    const filters = JSON.parse(localStorage.getItem(`analysisFilters`) || "{}");
    filters.modeFilter = e.target.value;
    // console.log("change values: ",filters);
    dispatch(setGlobalAnalysisFilter(filters));
    handleSearch();
  };

  const handleGoToNext = (page) => {
    setCurrentPage((prev) => prev + 1);
  };

  const handleGoToPrev = () => {
    setCurrentPage((prev) => prev - 1);
  };

  const handleResetCurrentPage = () => {
    setCurrentPage((prev) => 1);
  };

  const handleSetFilter = (e) => {
    setFilterData({ ...filterData, [e.target.name]: e.target.value });
    // handleSearch();
  };

  const handleGeneralAnalysis = () => {
    const prefix = isBusiness?"business":"admin";
    const data = { pageSize, currentPage, sort };
    const dataItem = handleApiDataHelper(data);
    dispatch(setGlobalAllAnalysisFilter(dataItem));
    navigate(`/${prefix}/analysis-dashboard/all`,{replace: false});
  };

  const handleSearch = () => {
    setSelectedEmailRecipients({});
    setSelectAllEmailPages(false);
    const data = { pageSize, currentPage, sort };

    data.isSearch = true;
    // if (filterData.search.length > 0) data.search = filterData.search;
    handleApiData(data);
  };

  const handleApiData = (data) => {
    const dataItem = handleApiDataHelper(data);
    dispatch(getQuestionAnalysis(dataItem));
  }
  const handleApiDataHelper = (data) => {
    const filters = JSON.parse(localStorage.getItem(`analysisFilters`) || "{}");

    if (filters.subjectFilter && filters.subjectFilter.length > 0) {
      data.subject = filters.subjectFilter;
    }

    if (filters.typeFilter && filters.typeFilter.length > 0) {
      data.type = filters.typeFilter;
    }
    if (filters.yearFilter && filters.yearFilter.length > 0) {
      data.year = filters.yearFilter;
    }
    if (filters.testFilter) {
      data.testFilter = filters.testFilter;
    }
    if (filters.modeFilter) {
      data.modeFilter = filters.modeFilter;
    }
    if (isAdmin && adminsdata.types.length === 0) data.is_filter = true;
    data.isAdmin = isAdmin;
    if (isBusiness && businessId) data.businessId = businessId;
    if (data.isAdmin) {
      data.start_date = date;
      data.end_date = dateEnd;
    }
    if (data.isSearch) {
      handleResetCurrentPage();
      data.currentPage = 1;
    }
   return data;
  };

  useEffect(() => {
    handleApiData({ pageSize, currentPage, sort });
  }, [pageSize, currentPage]);

  useEffect(() => {
    if (analysisdata && !analysisdata.loading &&
        analysisdata.pastQuestions &&
        analysisdata.pastQuestions.length) {
      const filters = JSON.parse(localStorage.getItem(`analysisFilters`) || "{}");
      if (filters.testFilter) {
        setAllAnalysis(true);
      }
      else{
        setAllAnalysis(false);
      }
    }
    // console.log("analysisdata.loading called",analysisdata.loading);
  }, [analysisdata.loading]);

  useEffect(() => {
    if(analysisdata.pastQuestions &&
        analysisdata.pastQuestions.length &&
        analysisdata.pastQuestions[0]['examEmail']){
      setMode('Email');
    }
    else if(analysisdata.pastQuestions &&
        analysisdata.pastQuestions.length &&
        analysisdata.pastQuestions[0]['session']){
      setMode('Test');
    }

    // console.log(analysisdata.pastQuestions);
  }, [analysisdata.pastQuestions]);
  useEffect(() => {

    return () => {
      const payload = {
        typeFilter: "",
        yearFilter: "",
        subjectFilter: "",
      };
      dispatch(setGlobalAnalysisFilter(payload));
    };
  }, []);

  return (
    <>
      <div>{isAdmin ? "" : <Navbar />}</div>
      <Desktop>
        <div className="test-analysis-div col-md-10 offset-md-1">
          <div className="flexy flexyM search-bar mt6">
            <div className="lisxt ">{!isAdmin && <h5>Test List</h5>}</div>
          </div>
          {isAdmin && !analysisdata.loading && analysisdata.pastQuestions && (
            // <div className="col-md-2 search-input offset-md-9 offset-2">
            //   <input name="search" type="search" placeholder="search JAMB, WAEC... Chemistry, Physics...
            //    " onChange={handleSetFilter}/>
            //   <img src={Icon} alt=""/>
            // </div>
            <>
              <AnalysisFilter
                isAdmin={isAdmin}
                handleClose={handleClose}
                show={show}
                Desktop={Desktop}
                TabletAndBelow={TabletAndBelow}
                handleSearch={handleSearch}
              />
              <div className="flexy sort flexyM filter">
              <div>
                <div>
                  <h6>Current Mode:</h6>
                  <div className="flexy">
                    <select value={mode} onChange={handleMode}>
                      {modeData.map((item, idx) => (
                          <option key={idx} value={item}>
                            {item}
                          </option>
                      ))}
                    </select>
                    {(mode && mode === 'Email')?(
                        <div className="col-md-1 ">
                          <button onClick={handleEmail}>
                            Send Email ({selectAllEmailPages ? "All" : Object.keys(selectedEmailRecipients).length})
                          </button>
                        </div>
                    ):""}
                  </div>
                </div>
              </div>
                {allAnalysis ?(
                <div className="col-md-1 ">
                    <button className="search no-mag" onClick={handleGeneralAnalysis}>
                      View Unified Analysis
                      <img src={IconDetail} alt="icon"/>
                    </button>
                  {/*</Link>*/}
                </div>):""}
               <div className="flexy sort filter">
                 <div className="App">
                   <div>
                     <label htmlFor="datestart">Start Date</label>
                     <Form.Control
                         type="date"
                         name="datestart"
                         placeholder="DateRange"
                         value={date}
                         onChange={(e) => setDate(e.target.value)}
                     />
                   </div>

                   <div>
                     <label htmlFor="dateend">End Date</label>
                     <Form.Control
                         type="date"
                         name="dateend"
                         placeholder="DateRange"
                         value={dateEnd}
                         onChange={(e) => setDateEnd(e.target.value)}
                     />
                   </div>
                 </div>
                 <div>
                   <h6>Sort by:</h6>
                   <select value={sort} onChange={handleSort}>
                     {sortData.map((item, idx) => (
                         <option key={idx} value={item}>
                           {item}
                         </option>
                     ))}
                   </select>
                 </div>
               </div>
              </div>
            </>
          )}
          {analysisdata.loading &&
            Array(pageSize)
              .fill()
              .map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <GhostExamListLoader></GhostExamListLoader>
                  </React.Fragment>
                );
              })}
          {!analysisdata.loading && analysisdata.pastQuestions && (
            <ExamAnalysis
              globalFilter={filterData}
              onGlobalFilterChange={handleSearch}
              data={analysisdata.pastQuestions}
              meta={analysisdata.questionsMeta}
              mode={mode}
              onGotoNextPage={handleGoToNext}
              onGotoPrevPage={handleGoToPrev}
              currentPage={currentPage}
              isAdmin={isAdmin}
              isBusiness={isBusiness}
              isRecipientSelected={isRecipientSelected}
              onToggleRecipient={handleToggleRecipient}
              areAllPagesSelected={selectAllEmailPages}
              onToggleAllPages={handleToggleAllPages}
              onToggleCurrentPageRecipients={handleToggleCurrentPageRecipients}
            />
          )}
        </div>
      </Desktop>
      <TabletAndBelow>
        <div className="mobile-ms">
          {analysisdata.loading &&
            Array(pageSize)
              .fill()
              .map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <GhostExamListMobileLoader></GhostExamListMobileLoader>
                  </React.Fragment>
                );
              })}
          {!analysisdata.loading && analysisdata.pastQuestions && (
            // <ExamAnalysis
            //     globalFilter={filterData}
            //     onGlobalFilterChange={handleSearch}
            //     data={analysisdata.pastQuestions}
            //     meta={analysisdata.questionsMeta}
            //     onGotoNextPage={handleGoToNext}
            //     onGotoPrevPage={handleGoToPrev}
            //     currentPage={currentPage}
            // />
            <ExamCardAnalysis
              globalFilter={filterData}
              onGlobalFilterChange={handleSearch}
              data={analysisdata.pastQuestions}
              meta={analysisdata.questionsMeta}
              handleGotoNext={handleGoToNext}
              handleGotoPrevious={handleGoToPrev}
              currentPage={currentPage}
            />
          )}
        </div>
      </TabletAndBelow>
    </>
  );
};
